module.exports = __webpack_public_path__ + "static/img/Illustration_3_OPS.e91d3533.svg";